import React, { useEffect, useState } from 'react';
import { useLocation } from 'react-router-dom';
import API from '../api/api';
import "./SearchResults.css";

function useQuery() {
  return new URLSearchParams(useLocation().search);
}

const SearchResults = () => {
  const q = useQuery().get('q') || '';
  const [results, setResults] = useState([]);
  const [videoUrl, setVideoUrl] = useState(null);

  // Convert YouTube link → embed URL
  const getEmbedUrl = (url) => {
    try {
      const parsed = new URL(url);

      // Normal YouTube videos
      if (parsed.hostname.includes("youtube.com") && parsed.pathname === "/watch") {
        const videoId = parsed.searchParams.get("v");
        return `https://www.youtube.com/embed/${videoId}?autoplay=1`;
      }

      // YouTube Shorts
      if (parsed.pathname.startsWith("/shorts/")) {
        const videoId = parsed.pathname.split("/shorts/")[1].split("?")[0];
        return `https://www.youtube.com/embed/${videoId}?autoplay=1`;
      }

      // youtu.be short links
      if (parsed.hostname === "youtu.be") {
        const videoId = parsed.pathname.replace("/", "");
        return `https://www.youtube.com/embed/${videoId}?autoplay=1`;
      }

      return "";
    } catch (_) {
      return "";
    }
  };

  useEffect(() => {
    API.get("/schemes")
      .then(res => {
        const data = res.data;
        const qLower = q.toLowerCase().trim();

        const words = qLower
          .split(" ")
          .filter(w => !["apply", "card", "service", "online"].includes(w));

        let matches = [];

        data.forEach(scheme => {
          if (!scheme.showInSchemeList && !scheme.showInState) return;

          scheme.categories.forEach(category => {
            if (!category.showInSchemeList && !category.showInState) return;

            category.subcategories.forEach(sub => {
              if (!sub.showInSchemeList && !sub.showInState) return;

              let score = 0;
              const subLower = sub.name.toLowerCase();
              const catLower = category.name.toLowerCase();
              const mainLower = scheme.mainCategory.toLowerCase();

              if (subLower === qLower) score += 50;

              words.forEach(w => {
                if (subLower.includes(w)) score += 20;
                if (catLower.includes(w)) score += 10;
                if (mainLower.includes(w)) score += 5;
              });

              if (score > 0) {
                matches.push({
                  mainCategory: scheme.mainCategory,
                  category: category.name,
                  subcategory: sub.name,
                  applyLink: sub.applyLink,
                  youtubeLink: sub.youtubeLink,
                  score
                });
              }
            });
          });
        });

        matches.sort((a, b) => b.score - a.score);
        setResults(matches);
      })
      .catch(console.error);
  }, [q]);

  return (
    <div className="search-wrapper">
      <div className="search-card shadow-lg">
        <h3 className="search-title text-center">
          Search Results for: "<span className="keyword">{q}</span>"
        </h3>

        <div className="underline"></div>

        {results.length === 0 ? (
          <p className="no-data text-center">No matching results found.</p>
        ) : (
          results.map((item, index) => (
            <div key={index} className="result-box shadow-sm">

              <h5 className="main-category">{item.mainCategory}</h5>
              <p><strong>Category:</strong> {item.category}</p>
              <p><strong>Service:</strong> {item.subcategory}</p>

              <div className="btn-group-flex mt-3">
                {item.applyLink && (
                  <a
                    href={item.applyLink}
                    target="_blank"
                    rel="noreferrer"
                    className="btn apply-btn"
                  >
                    Visit Website
                  </a>
                )}

                {item.youtubeLink && (
                  <button
                    className="btn video-btn"
                    onClick={() => setVideoUrl(getEmbedUrl(item.youtubeLink))}
                  >
                    Watch Video
                  </button>
                )}
              </div>
            </div>
          ))
        )}
      </div>

      {/* ---- VIDEO POPUP ---- */}
      {videoUrl && (
        <div className="video-modal-overlay" onClick={() => setVideoUrl(null)}>
          <div className="video-modal" onClick={(e) => e.stopPropagation()}>
            <iframe
              src={videoUrl}
              allow="autoplay; encrypted-media"
              allowFullScreen
              title="Video"
            ></iframe>

            <button className="close-btn" onClick={() => setVideoUrl(null)}>
              X
            </button>
          </div>
        </div>
      )}

    </div>
  );
};

export default SearchResults;
